import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { APP_TOAST_EVENT } from '../utils/toastEvents';

const DEFAULT_AUTO_HIDE_MS = 5000;
const VALID_SEVERITIES = new Set(['success', 'info', 'warning', 'error']);

const AppToast = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('info');
  const [autoHideDuration, setAutoHideDuration] = useState(DEFAULT_AUTO_HIDE_MS);

  useEffect(() => {
    const onAppToast = (event) => {
      const detail = event?.detail || {};
      const nextMessage = detail.message || 'Notification';
      const nextSeverity = VALID_SEVERITIES.has(detail.severity) ? detail.severity : 'info';
      const nextAutoHideDuration = Number.isFinite(detail.autoHideDuration)
        ? detail.autoHideDuration
        : DEFAULT_AUTO_HIDE_MS;

      setMessage(nextMessage);
      setSeverity(nextSeverity);
      setAutoHideDuration(nextAutoHideDuration);
      setOpen(true);
    };

    window.addEventListener(APP_TOAST_EVENT, onAppToast);
    return () => {
      window.removeEventListener(APP_TOAST_EVENT, onAppToast);
    };
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={() => setOpen(false)} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppToast;
